import React, { Fragment, useEffect, useState } from 'react';

import { formatFigure } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';
import CheckboxInput from 'CommonComponents/CheckboxInput';
import Tooltip from 'CommonComponents/Tooltip';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import CircleCheckIcon from 'Assets/icons/circle-check.svg';

export default function ProcurementExpensesForm(props) {
    const [selectedIds, setSelectedIds] = useState(JSON.parse(JSON.stringify(props.expensesIds)));
    const [selectionGroups, setSelectionsGroups] = useState({});
    const [render, setRender] = useState(false);
    const [hasSelectedExpenses, setHasSelectedExpenses] = useState(false);

    useEffect(() => {
        const res = {};
        fillSelectionGroups(res);
        setSelectionsGroups(res);
        setTimeout(() => {
            setRender(true);
        }, 0);
    }, []);

    useEffect(() => {
        setSelectedIds(JSON.parse(JSON.stringify(props.expensesIds)));
    }, [props.expensesIds]);

    useEffect(() => {
        let res = false;
        Object.keys(selectedIds).forEach((id) => {
            if (selectedIds[id]) {
                res = true;
            }
        });

        setHasSelectedExpenses(res);
    }, [selectedIds]);

    const handleSubmit = () => {
        const expenses_ids = [];

        Object.keys(selectedIds).forEach((id) => {
            if (selectedIds[id]) {
                expenses_ids.push(id);
            }
        });

        // Group toggles (template rows) are tracked in selectionGroups, not selectedIds.
        Object.keys(selectionGroups).forEach((groupId) => {
            if (selectionGroups[groupId]?.selected && selectionGroups[groupId]?.type === 'template') {
                expenses_ids.push(groupId);
            }
        });

        const normalizedExpenseIds = [...new Set(expenses_ids)];

        if (props.name && props.description) {
            const data = {
                name: props.name,
                description: props.description,
            };

            props.onSubmit(normalizedExpenseIds, data);
        } else {
            props.onSubmit(normalizedExpenseIds);
        }
    };

    const fillSelectionGroups = (res) => {
        const defaultObj = () => {
            return {
                selected: false,
                expenses: [],
                children: [],
                type: null,
            };
        };

        props.data.forEach((department) => {
            const processStructure = (structure, id = null) => {
                const packs = _.isArray(structure.packs) ? structure.packs : Object.values(structure.packs);
                packs.forEach((pack) => {
                    if (id) {
                        res[id].children.push(pack.id);
                    }

                    res[pack.id] = defaultObj();
                    res[pack.id].type = 'pack';
                    pack.expenses.forEach((exp) => {
                        res[pack.id].expenses.push(exp.id);
                    });
                });

                const templates = _.isArray(structure.templates) ? structure.templates : Object.values(structure.templates);
                templates.forEach((template) => {
                    if (id) {
                        res[id].children.push(template.id);
                    }

                    res[template.id] = defaultObj();
                    res[template.id].type = 'template';
                    template.expenses.forEach((exp) => {
                        res[template.id].expenses.push(exp.id);
                    });

                    const dividers = _.isArray(template.dividers) ? template.dividers : Object.values(template.dividers);
                    dividers.forEach((divider) => {
                        res[template.id].children.push(divider.id);

                        res[divider.id] = defaultObj();
                        res[divider.id].type = 'template_divider';
                        divider.expenses.forEach((exp) => {
                            res[divider.id].expenses.push(exp.id);
                        });
                    });
                });
            };

            Object.values(department.costcenters).forEach((cc) => {
                processStructure(cc);

                const projects = _.isArray(cc.projects) ? cc.projects : Object.values(cc.projects);
                projects.forEach((project) => {
                    res[project.id] = defaultObj();
                    res[project.id].type = 'project';
                    project.expenses.forEach((exp) => {
                        res[project.id].expenses.push(exp.id);
                    });
                    processStructure(project, project.id);
                });
            });
        });
    };

    const selectExpense = (id) => {
        const selected = JSON.parse(JSON.stringify(selectedIds));
        selected[id] = !selected[id];
        setSelectedIds(selected);
    };

    const selectExpenseGroup = (groupId) => {
        const idsToSelect = JSON.parse(JSON.stringify(selectedIds));
        const groupsToSelect = JSON.parse(JSON.stringify(selectionGroups));
        const value = !groupsToSelect[groupId].selected;

        const processGroup = (groupId) => {
            groupsToSelect[groupId].selected = value;
            groupsToSelect[groupId].expenses.forEach((exId) => {
                if (!props.existedIds.includes(exId) && !(props.lockedExpenseIds && props.lockedExpenseIds.includes(exId))) {
                    idsToSelect[exId] = value;
                }
            });
            if (groupsToSelect[groupId].children.length) {
                groupsToSelect[groupId].children.forEach((gId) => {
                    processGroup(gId);
                });
            }
        };

        processGroup(groupId);
        setSelectedIds(idsToSelect);
        setSelectionsGroups(groupsToSelect);
    };

    if (render) {
        return (
            <>
                <div className="inbud-table_wrapper">
                    <table className="inbud-table">
                        <thead>
                            <tr>
                                <th
                                    onClick={(e) => {
                                        props.setOrdering(e, 'name');
                                    }}
                                >
                                    {$t('Name')} <span>{props.arrow('name')}</span>
                                </th>
                                <th
                                    onClick={(e) => {
                                        props.setOrdering(e, 'value');
                                    }}
                                >
                                    {$t('Value')} <span>{props.arrow('value')}</span>
                                </th>
                                <th>{$t('Select')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.map((dep) => {
                                return Object.keys(dep.costcenters).map((ccDepId) => {
                                    return (
                                        <ProcurementExpensesTableGroupExpensesRows
                                            key={ccDepId}
                                            ccDepId={ccDepId}
                                            dep={dep}
                                            selectedIds={selectedIds}
                                            selectionGroups={selectionGroups}
                                            selectExpense={selectExpense}
                                            selectExpenseGroup={selectExpenseGroup}
                                            {...props}
                                        ></ProcurementExpensesTableGroupExpensesRows>
                                    );
                                });
                            })}
                        </tbody>
                    </table>
                </div>

                <div className="modal__footer">
                    <Button variant="danger" onClick={props.onCancel}>
                        {$t('Cancel')}
                    </Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={!hasSelectedExpenses}>
                        {$t('Save')}
                    </Button>
                </div>
            </>
        );
    }

    return <div></div>;
}

function ProcurementExpensesTableGroupExpensesRows({ dep, ccDepId, indent = 0, ...props }) {
    const [show, setShow] = useState(false);
    const cc = dep.costcenters[ccDepId];

    const packs = _.isArray(cc.packs) ? cc.packs : Object.values(cc.packs);
    const templates = _.isArray(cc.templates) ? cc.templates : Object.values(cc.templates);
    const projects = _.isArray(cc.projects) ? cc.projects : Object.values(cc.projects);
    return (
        <Fragment key={ccDepId}>
            <tr className={'!tw-bg-blue-25/20 tw-font-medium'}>
                <td colSpan={3}>
                    <div className="tw-flex tw-items-center tw-gap-x-1.5" style={{ paddingLeft: 6 * indent }}>
                        {dep.name} {cc.id !== null && <span>- {cc.name}</span>}
                        {!show && (
                            <div
                                style={{ marginLeft: props.defaultMargin ? props.defaultMargin : '0px' }}
                                className={'tw-cursor-pointer'}
                                onClick={() => setShow(true)}
                            >
                                <ChevronDownIcon className={'tw-h-3.5 tw-w-3.5'} />
                            </div>
                        )}
                        {!!show && (
                            <div
                                style={{ marginLeft: props.defaultMargin ? props.defaultMargin : '0px' }}
                                className={'tw-cursor-pointer'}
                                onClick={() => setShow(false)}
                            >
                                <ChevronUpIcon className={'tw-h-3.5 tw-w-3.5'} />
                            </div>
                        )}
                    </div>
                </td>
            </tr>

            {show && (
                <>
                    <ProcurementExpensesTableGroupLines
                        prefix={`ccCollapse-${ccDepId}`}
                        multiCollapsePrefix={`multi-collapse-${ccDepId}`}
                        expensePrefix={`${ccDepId}`}
                        expenses={cc.expenses}
                        packs={packs}
                        templates={templates}
                        selectedIds={props.selectedIds}
                        selectionGroups={props.selectionGroups}
                        selectExpense={props.selectExpense}
                        selectExpenseGroup={props.selectExpenseGroup}
                        dep={dep}
                        cc={cc}
                        defaultMargin={0}
                        existedIds={props.existedIds}
                        lockedExpenseIds={props.lockedExpenseIds}
                        indent={indent + 1}
                    />
                    {projects.length > 0 &&
                        projects.map((project) => (
                            <ProcurementExpensesTableGroupProjectsLines
                                key={`${ccDepId}-projects-${project.id}`}
                                expensePrefix={`${ccDepId}-projects-${project.id}`}
                                selectedIds={props.selectedIds}
                                selectionGroups={props.selectionGroups}
                                selectExpense={props.selectExpense}
                                selectExpenseGroup={props.selectExpenseGroup}
                                dep={dep}
                                cc={cc}
                                defaultMargin={10}
                                existedIds={props.existedIds}
                                project={project}
                                indent={indent + 1}
                                {...props}
                            ></ProcurementExpensesTableGroupProjectsLines>
                        ))}
                </>
            )}
        </Fragment>
    );
}

function ProcurementExpensesTableGroupProjectsLines({ project, ccDepId, indent = 0, ...props }) {
    const [show, setShow] = useState(false);
    const projectId = project.id;
    const projectPacks = _.isArray(project.packs) ? project.packs : Object.values(project.packs);
    const projectTemplates = _.isArray(project.templates) ? project.templates : Object.values(project.templates);
    const multiCollapsePrefix = `multi-collapse-${ccDepId}-projects-${projectId}`;
    const prefix = `multi-collapse-${ccDepId}-projects-${projectId}`; //
    const dep = props.dep;
    const cc = props.cc;

    return (
        <Fragment key={`${ccDepId}-projects-${projectId}`}>
            <tr className="!tw-bg-white">
                <td>
                    <div className="tw-flex tw-items-center tw-gap-x-1.5">
                        <span style={{ paddingLeft: 6 * indent }}>{project.name}</span>
                        {!show && (
                            <div
                                style={{ marginLeft: props.defaultMargin ? props.defaultMargin : '0px' }}
                                className={'tw-cursor-pointer'}
                                onClick={() => setShow(true)}
                            >
                                <ChevronDownIcon className={'tw-h-3.5 tw-w-3.5'} />
                            </div>
                        )}
                        {!!show && (
                            <div
                                style={{ marginLeft: props.defaultMargin ? props.defaultMargin : '0px' }}
                                className={'tw-cursor-pointer'}
                                onClick={() => setShow(false)}
                            >
                                <ChevronUpIcon className={'tw-h-3.5 tw-w-3.5'} />
                            </div>
                        )}
                    </div>
                </td>
                <td>
                    <span>{formatFigure(project.value)}</span>
                </td>
                <td></td>
            </tr>

            {show && (
                <ProcurementExpensesTableGroupLines
                    prefix={prefix}
                    multiCollapsePrefix={multiCollapsePrefix}
                    expensePrefix={`${ccDepId}-projects-${projectId}`}
                    expenses={project.expenses}
                    packs={projectPacks}
                    templates={projectTemplates}
                    selectedIds={props.selectedIds}
                    selectionGroups={props.selectionGroups}
                    selectExpense={props.selectExpense}
                    selectExpenseGroup={props.selectExpenseGroup}
                    dep={dep}
                    cc={cc}
                    defaultMargin={10}
                    existedIds={props.existedIds}
                    lockedExpenseIds={props.lockedExpenseIds}
                    indent={indent + 1}
                />
            )}
        </Fragment>
    );
}

function ProcurementExpensesTableGroupPacksLines({ pack, backgroundClass, indent = 0, ...props }) {
    const [show, setShow] = useState(false);
    const packId = pack.id;
    const prefix = props.prefix; //ccCollapse-${ccDepId} or ccCollapse-${ccDepId}-projects-${projectId}
    const multiCollapsePrefix = props.multiCollapsePrefix; //multi-collapse-${ccDepId} or multi-collapse-${ccDepId}-projects-${projectId}
    const expensePrefix = props.expensePrefix; // ${ccDepId} or ${ccDepId}-projects-${projectId}
    const selectedIds = props.selectedIds;
    const selectionGroups = props.selectionGroups;
    const selectExpense = props.selectExpense;
    const selectExpenseGroup = props.selectExpenseGroup;
    const dep = props.dep;
    const cc = props.cc;
    const defaultMargin = props.defaultMargin ? parseInt(props.defaultMargin) : 0;
    return (
        <Fragment key={`${expensePrefix}-packs-${packId}`}>
            <ProcurementExpensesTableExpandedLine
                backgroundClass={backgroundClass}
                setShowFlag={setShow}
                show={show}
                targetStr={`.${multiCollapsePrefix}-packs-${packId}-expenses`}
                controlsStr={`${prefix}-packs-${packId}-expenses`}
                marginLeft={defaultMargin + 10 + 'px'}
                selectionGroups={selectionGroups}
                changeHandler={selectExpenseGroup}
                dep={dep}
                cc={cc}
                item={pack}
                existedIds={props.existedIds}
                lockedExpenseIds={props.lockedExpenseIds}
                indent={indent}
            />
            {show && (
                <ProcurementExpensesTableExpensesLines
                    backgroundClass="!tw-bg-white"
                    keyPrefix={`${expensePrefix}-packs-${packId}-expense-`}
                    expenses={pack.expenses}
                    selectedIds={selectedIds}
                    changeHandler={selectExpense}
                    dep={dep}
                    cc={cc}
                    marginLeft={defaultMargin + 20 + 'px'}
                    existedIds={props.existedIds}
                    lockedExpenseIds={props.lockedExpenseIds}
                    indent={indent + 1}
                />
            )}
        </Fragment>
    );
}

function ProcurementExpensesTableGroupTemplatesLines({ template, backgroundClass = '!tw-bg-white', indent = 0, ...props }) {
    const [show, setShow] = useState(false);
    const prefix = props.prefix; //ccCollapse-${ccDepId} or ccCollapse-${ccDepId}-projects-${projectId}
    const multiCollapsePrefix = props.multiCollapsePrefix; //multi-collapse-${ccDepId} or multi-collapse-${ccDepId}-projects-${projectId}
    const expensePrefix = props.expensePrefix; // ${ccDepId} or ${ccDepId}-projects-${projectId}
    const dep = props.dep;
    const cc = props.cc;
    const defaultMargin = props.defaultMargin ? parseInt(props.defaultMargin) : 0;

    const templateId = template.id;
    const dividers = _.isArray(template.dividers) ? template.dividers : Object.values(template.dividers);

    return (
        <Fragment key={`${expensePrefix}-templates-${templateId}`}>
            <ProcurementExpensesTableExpandedLine
                backgroundClass={backgroundClass}
                setShowFlag={setShow}
                show={show}
                targetStr={`.${multiCollapsePrefix}-templates-${templateId}-expenses`}
                controlsStr={`${prefix}-templates-${templateId}-expenses`}
                marginLeft={defaultMargin + 10 + 'px'}
                selectionGroups={props.selectionGroups}
                changeHandler={props.selectExpenseGroup}
                dep={dep}
                cc={cc}
                item={template}
                existedIds={props.existedIds}
                lockedExpenseIds={props.lockedExpenseIds}
                indent={indent}
            />
            {show && (
                <>
                    <ProcurementExpensesTableExpensesLines
                        backgroundClass="!tw-bg-white"
                        keyPrefix={`${expensePrefix}-templates-${templateId}-expense-`}
                        expenses={template.expenses}
                        selectedIds={props.selectedIds}
                        changeHandler={props.selectExpense}
                        dep={dep}
                        cc={cc}
                        marginLeft={defaultMargin + 20 + 'px'}
                        existedIds={props.existedIds}
                        lockedExpenseIds={props.lockedExpenseIds}
                        indent={indent + 1}
                    />
                    {dividers.length > 0 && (
                        <>
                            {dividers.map((divider) => {
                                return (
                                    <ProcurementExpensesTableGroupTemplateDividersLines
                                        key={divider.id}
                                        backgroundClass="!tw-bg-white"
                                        template={template}
                                        divider={divider}
                                        indent={indent + 1}
                                        {...props}
                                    ></ProcurementExpensesTableGroupTemplateDividersLines>
                                );
                            })}
                        </>
                    )}
                </>
            )}
        </Fragment>
    );
}

function ProcurementExpensesTableGroupTemplateDividersLines({ template, divider, backgroundClass, ...props }) {
    const [show, setShow] = useState(false);
    const prefix = props.prefix; //ccCollapse-${ccDepId} or ccCollapse-${ccDepId}-projects-${projectId}
    const multiCollapsePrefix = props.multiCollapsePrefix; //multi-collapse-${ccDepId} or multi-collapse-${ccDepId}-projects-${projectId}
    const expensePrefix = props.expensePrefix; // ${ccDepId} or ${ccDepId}-projects-${projectId}
    const dep = props.dep;
    const cc = props.cc;
    const defaultMargin = props.defaultMargin ? parseInt(props.defaultMargin) : 0;
    const indent = props.indent ? props.indent : 0;

    const templateId = template.id;
    const dividerId = divider.id;

    return (
        <Fragment key={`${expensePrefix}-templates-${templateId}-dividers-${dividerId}`}>
            <ProcurementExpensesTableExpandedLine
                backgroundClass={backgroundClass}
                setShowFlag={setShow}
                show={show}
                targetStr={`.${multiCollapsePrefix}-templates-${templateId}-dividers-${dividerId}-expenses`}
                controlsStr={`${prefix}-templates-${templateId}-dividers-${dividerId}-expenses`}
                marginLeft={defaultMargin + 20 + 'px'}
                selectionGroups={props.selectionGroups}
                changeHandler={props.selectExpenseGroup}
                dep={dep}
                cc={cc}
                item={divider}
                isDivider={true}
                existedIds={props.existedIds}
                lockedExpenseIds={props.lockedExpenseIds}
                indent={indent}
            />
            {show && (
                <ProcurementExpensesTableExpensesLines
                    backgroundClass="!tw-bg-white"
                    keyPrefix={`${expensePrefix}-templates-${templateId}-dividers-${dividerId}-expense-`}
                    expenses={divider.expenses}
                    selectedIds={props.selectedIds}
                    changeHandler={props.selectExpense}
                    dep={dep}
                    cc={cc}
                    marginLeft={defaultMargin + 30 + 'px'}
                    existedIds={props.existedIds}
                    lockedExpenseIds={props.lockedExpenseIds}
                    indent={indent + 1}
                />
            )}
        </Fragment>
    );
}

function ProcurementExpensesTableGroupLines({ backgroundClass = '!tw-bg-white', ...props }) {
    const prefix = props.prefix; //ccCollapse-${ccDepId} or ccCollapse-${ccDepId}-projects-${projectId}
    const multiCollapsePrefix = props.multiCollapsePrefix; //multi-collapse-${ccDepId} or multi-collapse-${ccDepId}-projects-${projectId}
    const expensePrefix = props.expensePrefix; // ${ccDepId} or ${ccDepId}-projects-${projectId}
    const expenses = props.expenses;
    const packs = props.packs;
    const templates = props.templates;
    const selectedIds = props.selectedIds;
    const selectionGroups = props.selectionGroups;
    const selectExpense = props.selectExpense;
    const selectExpenseGroup = props.selectExpenseGroup;
    const dep = props.dep;
    const cc = props.cc;
    const defaultMargin = props.defaultMargin ? parseInt(props.defaultMargin) : 0;
    const indent = props.indent ? props.indent : 0;

    return (
        <>
            {/*Simple Expenses*/}
            <Fragment key={`${prefix}-expenses`}>
                <ProcurementExpensesTableExpensesLines
                    backgroundClass={backgroundClass}
                    keyPrefix={`${expensePrefix}-`}
                    expenses={expenses}
                    selectedIds={selectedIds}
                    changeHandler={selectExpense}
                    dep={dep}
                    cc={cc}
                    marginLeft={defaultMargin + 10 + 'px'}
                    existedIds={props.existedIds}
                    lockedExpenseIds={props.lockedExpenseIds}
                    indent={indent}
                />
            </Fragment>

            {/*Packs*/}
            {packs.length > 0 && (
                <>
                    <tr className={backgroundClass}>
                        <td colSpan="6">
                            <span className="!tw-text-charcoal-75 !tw-font-semibold" style={{ paddingLeft: 6 * indent }}>
                                {$t('Packs')}
                            </span>
                        </td>
                    </tr>

                    {packs.map((pack) => {
                        return (
                            <ProcurementExpensesTableGroupPacksLines
                                key={pack.id}
                                backgroundClass={backgroundClass}
                                pack={pack}
                                {...props}
                            ></ProcurementExpensesTableGroupPacksLines>
                        );
                    })}
                </>
            )}

            {/*Templates*/}
            {templates.length > 0 &&
                templates.map((template) => (
                    <ProcurementExpensesTableGroupTemplatesLines key={template.id} template={template} {...props}></ProcurementExpensesTableGroupTemplatesLines>
                ))}
        </>
    );
}

function ProcurementExpensesTableExpensesLines({ backgroundClass, ...props }) {
    return (
        <>
            {props.expenses.map((expense) => {
                return (
                    <ProcurementExpensesTableExpensesLine
                        backgroundClass={backgroundClass}
                        key={`${props.keyPrefix}${expense.id}`}
                        keyPrefix={props.keyPrefix}
                        expense={expense}
                        selectedIds={props.selectedIds}
                        changeHandler={props.changeHandler}
                        dep={props.dep}
                        cc={props.cc}
                        marginLeft={props.marginLeft}
                        existedIds={props.existedIds}
                        indent={props.indent}
                        lockedExpenseIds={props.lockedExpenseIds}
                    />
                );
            })}
        </>
    );
}

const ProcurementExpensesTableExpensesLine = ({ backgroundClass, ...props }) => {
    const indent = props.indent ? props.indent : 0;
    const isLocked = props.lockedExpenseIds && props.lockedExpenseIds.includes(props.expense.id);
    const lockedTooltip = props.dep?.name
        ? $t('Owned by {{department}} — add/delete centrally', { department: props.dep.name })
        : $t('Owned by another department — add/delete centrally');

    return (
        <tr key={`${props.keyPrefix}${props.expense.id}`} className={`${backgroundClass}${isLocked ? ' tw-opacity-50' : ''}`}>
            <td>
                {isLocked ? (
                    <Tooltip tooltipContent={lockedTooltip} tooltipType="text" offset={[16, 16]}>
                        <span style={{ paddingLeft: 6 * indent }}>{props.expense.name}</span>
                    </Tooltip>
                ) : (
                    <Tooltip
                        tooltipContent={!props.expense.description ? '' : props.expense.description}
                        tooltipType="text"
                        offset={[16, 16]}
                        allowTooltip={!!props.expense.description}
                    >
                        <span style={{ paddingLeft: 6 * indent }}>{props.expense.name}</span>
                    </Tooltip>
                )}
            </td>

            <td>
                <span>{formatFigure(props.expense.value)}</span>
            </td>
            <td>
                <div className="tw-flex flex-row tw-justify-center tw-items-center">
                    {isLocked && props.existedIds.includes(props.expense.id) && <CircleCheckIcon className="tw-w-5 tw-h-5 tw-text-green" aria-hidden="true" />}
                    {isLocked && !props.existedIds.includes(props.expense.id) && (
                        <CheckboxInput value={false} checked={false} onChange={() => {}} disabled={true} />
                    )}
                    {!isLocked && props.existedIds.includes(props.expense.id) && <CircleCheckIcon className="tw-w-5 tw-h-5 tw-text-green" aria-hidden="true" />}
                    {!isLocked && !props.existedIds.includes(props.expense.id) && (
                        <CheckboxInput
                            value={props.selectedIds[props.expense.id]}
                            checked={props.selectedIds[props.expense.id]}
                            onChange={() => {
                                props.changeHandler(props.expense.id);
                            }}
                        />
                    )}
                </div>
            </td>
        </tr>
    );
};

const ProcurementExpensesTableExpandedLine = (props) => {
    const indent = props.indent ? props.indent : 0;
    const groupExpenses = props.selectionGroups[props.item.id]?.expenses || [];
    const selectableExpenses = groupExpenses.filter(
        (exId) => !props.existedIds?.includes(exId) && !(props.lockedExpenseIds && props.lockedExpenseIds.includes(exId)),
    );
    const allLocked = groupExpenses.length > 0 && selectableExpenses.length === 0;

    return (
        <tr className={props.backgroundClass}>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-1.5" style={{ paddingLeft: 6 * indent }}>
                    <Tooltip
                        tooltipContent={!props.item.description ? '' : props.item.description}
                        tooltipType="text"
                        offset={[16, 16]}
                        allowTooltip={!!props.item.description}
                    >
                        <span>{props.item.name}</span>
                    </Tooltip>
                    {!props.show && (
                        <div
                            style={{ marginLeft: props.marginLeft ? props.marginLeft : '0px' }}
                            className={'tw-cursor-pointer'}
                            onClick={() => props.setShowFlag(true)}
                        >
                            <ChevronDownIcon className={'tw-h-3.5 tw-w-3.5'} />
                        </div>
                    )}
                    {!!props.show && (
                        <div
                            style={{ marginLeft: props.marginLeft ? props.marginLeft : '0px' }}
                            className={'tw-cursor-pointer'}
                            onClick={() => props.setShowFlag(false)}
                        >
                            <ChevronUpIcon className={'tw-h-3.5 tw-w-3.5'} />
                        </div>
                    )}
                </div>
            </td>

            <td>{!props.isDivider && <span>{formatFigure(props.item.value)}</span>}</td>
            <td>
                <div className="tw-flex flex-row tw-justify-center tw-items-center">
                    <CheckboxInput
                        value={props.selectionGroups[props.item.id].selected}
                        checked={props.selectionGroups[props.item.id].selected}
                        disabled={allLocked}
                        onChange={() => {
                            if (!allLocked) {
                                props.changeHandler(props.item.id);
                            }
                        }}
                    />
                </div>
            </td>
        </tr>
    );
};
